import { render } from "./Supplier.vue?vue&type=template&id=e36d114c&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=ts"
export * from "./Supplier.vue?vue&type=script&lang=ts"

import "./Supplier.vue?vue&type=style&index=0&id=e36d114c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e36d114c"

export default script